/**
 * MinaRoMina Wallpaper PRO - JavaScript
 * Inicialización de PhotoSwipe para galería vertical configurable
 */

(function() {
  'use strict';

  // Track initialized galleries to prevent duplicate initialization
  const initializedGalleries = new Set();

  /**
   * Initialize wallpaper PRO gallery with PhotoSwipe
   * @param {string} galleryId - ID of the gallery element
   */
  function initWallpaperProGallery(galleryId) {
    if (!galleryId || initializedGalleries.has(galleryId)) {
      return;
    }

    const galleryEl = document.getElementById(galleryId);
    if (!galleryEl) {
      console.warn('[MRM Wallpaper PRO] Gallery not found:', galleryId);
      return;
    }

    // Check if PhotoSwipe is available
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
      console.warn('[MRM Wallpaper PRO] PhotoSwipe not loaded, retrying...');
      setTimeout(() => initWallpaperProGallery(galleryId), 500);
      return;
    }

    try {
      const lightbox = new PhotoSwipeLightbox({
        gallery: '#' + galleryId,
        children: 'a.mrm-wallpaper-item',
        pswpModule: PhotoSwipe,

        // UI options
        showHideAnimationType: 'fade',
        showAnimationDuration: 333,
        hideAnimationDuration: 333,

        // Zoom options
        zoom: true,
        wheelToZoom: true,
        pinchToClose: true,

        // Layout
        padding: { top: 20, bottom: 40, left: 20, right: 20 },

        // Preload
        preload: [1, 2],
      });

      // Add event listeners
      lightbox.on('uiRegister', function() {
        console.log('[MRM Wallpaper PRO] PhotoSwipe UI registered');
      });

      lightbox.on('change', function() {
        console.log('[MRM Wallpaper PRO] Slide changed');
      });

      lightbox.init();
      initializedGalleries.add(galleryId);

      console.log('[MRM Wallpaper PRO] ✅ Gallery initialized:', galleryId);
    } catch (error) {
      console.error('[MRM Wallpaper PRO] Initialization error:', error);
    }
  }

  /**
   * Initialize all wallpaper PRO galleries on the page
   */
  function initAllGalleries() {
    const galleries = document.querySelectorAll('[id^="WallpaperProGallery-"]');

    galleries.forEach(function(gallery) {
      if (gallery.id && !initializedGalleries.has(gallery.id)) {
        initWallpaperProGallery(gallery.id);
      }
    });

    if (galleries.length === 0) {
      console.log('[MRM Wallpaper PRO] No galleries found on page');
    }
  }

  /**
   * Cleanup gallery when section is removed (theme editor)
   * @param {string} galleryId - ID of the gallery to cleanup
   */
  function cleanupGallery(galleryId) {
    if (initializedGalleries.has(galleryId)) {
      initializedGalleries.delete(galleryId);
      console.log('[MRM Wallpaper PRO] Gallery cleaned up:', galleryId);
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  // Theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    // Re-initialize when section is loaded/reloaded
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId) {
        const galleryId = 'WallpaperProGallery-' + e.detail.sectionId;
        setTimeout(() => initWallpaperProGallery(galleryId), 100);
      }
    });

    // Cleanup when section is unloaded
    document.addEventListener('shopify:section:unload', function(e) {
      if (e.detail && e.detail.sectionId) {
        const galleryId = 'WallpaperProGallery-' + e.detail.sectionId;
        cleanupGallery(galleryId);
      }
    });

    // Re-initialize when section is reloaded (settings changed)
    document.addEventListener('shopify:section:reorder', function() {
      console.log('[MRM Wallpaper PRO] Section reordered, re-checking galleries');
      setTimeout(initAllGalleries, 200);
    });
  }

  // Export for debugging (only in development)
  if (window.location.hostname === 'localhost' || window.location.hostname.includes('.myshopify.com')) {
    window.mrmWallpaperPro = {
      init: initWallpaperProGallery,
      initAll: initAllGalleries,
      cleanup: cleanupGallery,
      galleries: initializedGalleries
    };
  }

  console.log('[MRM Wallpaper PRO] Script loaded and ready');
})();
